import React from 'react';
import async from 'async';

import {
  BottomNavigation,
  BottomNavigationItem,
  Paper,
  FontIcon, MenuItem, IconMenu, IconButton, Avatar,
} from 'material-ui';
import { connect } from 'react-redux';
import DateTime from 'react-datetime';
import Modal from 'react-responsive-modal';
import { Form, FormInput } from 'react-form';
import { Card, CardText } from 'material-ui';
import _ from 'lodash';
import Translate from 'translate';
import moment from 'moment';

import IncmsService from 'services/IncmsService'
import { Text, DatePicker, Select, FormGroup } from 'components/FormElements/';
import { toggleLoading } from 'stores/actions/';

class SearchComplaintLECModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      selectedRightTabIndex:0,
      serviceNumber:null,
      data: [],
      evtLocationOptions:[ {description:"default",id:1}],
      evtStatusOptions:[{"description":"PENDING","id":1},
                        {"description":"APPROVED","id":2},
                        {"description":"REQUESTED","id":3},
                        {"description":"CANCELED","id":4},
                        {"description":"REJECTED","id":5},
                        {"description":"ATTENTION","id":6},
                        {"description":"GENERATED","id":7},
                        {"description":"CLOSED","id":8},
                        {"description":"RESOLVED","id":9},
                        {"description":"UNFOUNDED","id":10},
                        {"description":"ABORTED","id":11},
                        {"description":"DISPATCHED","id":12},
                        {"description":"ARRIVED","id":13},
                        {"description":"RESTITUTION","id":14},
                        {"description":"PROROGATED","id":15}],
      submitted: false
    };
    //this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
    
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.open && !this.props.open ) {
      this.getData();
      this.setState( { data: [], submitted: false } );
      if ((this.props.activeAccount) && (this.props.activeAccount.incmsDataobj ))
      {
        this.setState({serviceNumber:  this.props.activeAccount.incmsDataobj.account})
      } else {
        this.setState({serviceNumber:  null})
      }
      
    }

    
  }

  getData() {
    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    async.parallel( {
      locations: this.getLocations.bind( this ),

    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );
      
      this.setState( {
        locations: results.locations,
      } )
    } )
  }

  getLocations( cb ) {
    IncmsService.getLocations()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  submitForm( data ) {
    this.props.toggleLoading( true );
    console.log("serviceNumber = null ", data.serviceNumber === null, data.serviceNumber==='' )
    data.evtStartDateTimeFrom = data.evtStartDateTimeFrom ? moment( data.evtStartDateTimeFrom ).format('YYYY-MM-DD')  :  moment(this.state.evtStartDateTimeFrom).format('YYYY-MM-DD')
    data.evtStartDateTimeTo = data.evtStartDateTimeTo ? moment( data.evtStartDateTimeTo ).format('YYYY-MM-DD')  :  moment(this.state.evtStartDateTimeTo).format('YYYY-MM-DD')
    if (data.serviceNumber === ''){
        delete data.serviceNumber;
    }

    IncmsService.searchComplaintLEC( data ).then( ( response ) => {
      if ( response.data ) {
        this.setState( { data: response.data, submitted: true } );
      } else {
        this.setState( { submitted: true } );
      }
      this.props.toggleLoading( false );
    } )
  }
  setActiveTabRight( index ) {
    this.setState( { selectedRightTabIndex: index } )
  }
  render() {
    const { onSelectCard, onClose, open, activeAccount } = this.props;
    const { 
      evtLocationOptions, 
      evtStatusOptions,
      evtStatus, 
      evtLocation, 
      selectedRightTabIndex, 
      serviceNumber,
      reference,
      evtStartDateTimeFrom,
      evtStartDateTimeTo,
      locations,
    } = this.state;
    //console.log(" ACTIVE ACCPOTN " ,activeAccount.incmsDataobj.account);
    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="modal-search-incms col-md-8"
             open={open}
             onClose={() => {
               this.setState( { data: [] } );
               onClose()
             }}>
        <h5 className="mt-0"><Translate id="searchOutages"/></h5>

        <Form onSubmit={this.submitForm}
          defaultValues={{ 
            serviceNumber: serviceNumber,
            reference: reference,
            evtStartDateTimeFrom: evtStartDateTimeFrom,
            evtStartDateTimeTo: evtStartDateTimeTo,
            evtLocation: evtLocation,
            evtStatus: evtStatus

          }}
        >
          {( { getValue,setValue, submitForm } ) =>
            <form onSubmit={submitForm} className="mt-4">

            <Paper zDepth={1} style={{ boxShadow: 'none', borderBottom: '1px solid #E9E9E9' }}>
                <BottomNavigation selectedIndex={selectedRightTabIndex} style={{ height: 48 }}>

                  <BottomNavigationItem
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                    label={
                      <div>
                        <i className="list-ul mr-1"/>
                        <Translate id="reportedOutages"/>
                      </div>}
                    icon={<span/>}
                    onClick={() => {this.setActiveTabRight( 0 ); setValue("referenceNumber",null); this.setState( { reference: null }) }}
                  />

                  <BottomNavigationItem
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                    label={
                      <div>
                        <i className="calendar-check mr-1"/>
                        <Translate id="plannedOutages"/>
                      </div>}
                    icon={<span/>}
                    onClick={() => {this.setActiveTabRight( 1 ); setValue("referenceNumber",null); this.setState( { reference: null }) }}
                  />
                </BottomNavigation>
            </Paper>
            ̣{selectedRightTabIndex === 0 &&
              <div className="row mb-3">
                  <div className="col-md-6">
                    <FormGroup>
                      <label>
                        <Translate id="referenceNumber"/>
                      </label>
                        <Text field="reference"
                          clearable="true"
                          onChange={( value ) => {
                            this.setState( { reference: value })
                          }}
                          className="form-control"/>
                    </FormGroup>
                  </div>
              </div>
              }
            ̣{selectedRightTabIndex === 1 &&
              <div className="row mb-3">
                  <div className="col-md-6">
                    <FormGroup>
                      <label>
                        <Translate id="serviceNumber"/>
                      </label>
                        <Text field="serviceNumber"
                          clearable="true"
                          onChange={( value ) => {
                            this.setState( { serviceNumber: value })
                          }}
                          className="form-control"/>
                    </FormGroup>
                  </div>
              </div>
              }
              {selectedRightTabIndex === 1 &&
                <div className="row mb-3">
                  <div className="col-md-6">
                    <FormGroup>
                      <label>
                        <Translate id="evtStartDateTimeFrom"/>
                      </label>
                      <FormInput field="evtStartDateTimeFrom">
                        {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                          <div className="input-group">
                          <DateTime
                                onChange={(value)=>{ setValue(value); this.setState( { evtStartDateTimeFrom: value }) }}
                                onBlur={setTouched}
                                value={getValue() ? moment( getValue() ).format( 'YYYY-MM-DD' ) :  moment(  evtStartDateTimeFrom).format( 'YYYY-MM-DD' )}
                                field="evtStartDateTimeFrom"
                                dateFormat={'YYYY-MM-DD'}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{
                                  className: 'form-control bg-color-white',
                                  readOnly: false
                                }}
                            />
                          </div>
                        }
                      </FormInput>
                  </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                      <label>
                        <Translate id="evtStartDateTimeTo"/>
                      </label>
                      <FormInput field="evtStartDateTimeTo">
                        {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                          <div className="input-group">
                          <DateTime
                                onChange={(value)=>{ setValue(value); this.setState( { evtStartDateTimeTo: value })  }}
                                onBlur={setTouched}
                                value={getValue() ? moment( getValue() ).format( 'YYYY-MM-DD' ) :  moment(  evtStartDateTimeTo).format('YYYY-MM-DD' )}
                                field="evtStartDateTimeTo"
                                dateFormat={'YYYY-MM-DD'}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{
                                  className: 'form-control bg-color-white',
                                  readOnly: false
                                }}
                            />
                          </div>
                        }
                      </FormInput>
                    </FormGroup>
                  </div>
                </div>
              }
              {selectedRightTabIndex === 1 &&
                <div className="row mb-3">
                  <div className="col-md-6">
                    <FormGroup>
                      <label>
                        <Translate id="evtStatus"/>
                      </label>
                      <Select
                          field="evtStatus"
                          clearable={true}
                          onChange={( value ) => {
                            //const personalIdType = _.find( personalIdTypes, { id: value } );
                            //if( personalIdType ) {
                              this.setState( { evtStatus: value })
                            //}
                          }}
                          options={evtStatusOptions}
                          className="form-control"
                          labelKey="description"
                          searchable={false}
                          value={evtStatus}
                        />
                  </FormGroup>
                  </div>
                  <div className="col-md-6">
                  <FormGroup>
                    <label>
                        <Translate id="evtLocation"/>
                      </label>
                      <Select
                          field="evtLocation"
                          clearable={true}
                          onChange={( value ) => {
                            //const personalIdType = _.find( personalIdTypes, { id: value } );
                            //if( personalIdType ) {
                              this.setState( { evtLocation: value })
                            //}
                          }}
                          options={locations}
                          className="form-control"
                          labelKey="description"
                          valueKey="id"
                          searchable={false}
                          value={evtLocation}
                        />
                    </FormGroup>
                  </div>
                </div>
              }

              <hr/>
              <div className="text-right">
                <button className="btn btn-info"
                        disabled={!getValue( 'serviceNumber' )
                                  && !getValue( 'evtStartDateTimeTo' )
                                  && !getValue( 'evtStartDateTimeFrom' )
                                  && !getValue( 'reference' )
                                  && !getValue( 'evtStatus' )
                                  && !getValue( 'evtLocation' ) }>
                  <Translate id="submit"/>
                </button>
              </div>
            </form>
          }
        </Form>

        <div className="row content mt-3">
          {_.map( this.state.data, ( item, index ) =>

            <div key={index} className="col-md-6 mt-1 mb-3">

              <Card containerStyle={{ cursor: 'pointer' }} onClick={() => {
                onClose();
                
              }}>
                <CardText>
                  <div className="col-md-12 p-0">
                    <div className="row">
                      <div className="col-md-3"><Translate id="evtId"/></div>
                      <div className="col-md-9 text-small text-muted">{item.evtId || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="evtStartDateTime"/></div>
                      <div className="col-md-9 text-small text-muted">{item.evtStartDateTime}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="evtEndDateTime"/></div>
                      <div className="col-md-9 text-small text-muted">{item.evtEndDateTime}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="evtClassDesciption"/></div>
                      <div className="col-md-9 text-small text-muted">{item.evtClassDesciption}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="evtStatusDesciption"/></div>
                      <div className="col-md-9 text-small text-muted">{item.evtStatusDesciption}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="evtLocationDesciption"/></div>
                      <div className="col-md-9 text-small text-muted">{item.evtLocationDesciption || '---'}</div>
                    </div>


                  </div>
                </CardText>
              </Card>
            
            </div>
          )}
          { this.state.submitted && this.state.data && this.state.data.length === 0 &&
          <div className="col-md-12 text-center">
            <h5 className="text-muted mt-0"><Translate id="noDataFound"/></h5>
          </div>
          }
        </div>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( SearchComplaintLECModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/SearchComplaintLECModal/index.js